import { GDFTafRecord } from '../../../gdf/type';
import { flightCategoryToString } from '../../../utils/enum-display';
import { feetToMeters } from './MetarTooltip';

const ltGt: Record<NonNullable<GDFTafRecord['visualLessGt']>, string> = {
    L: '< ',
    G: '> '
};

export default function TafTooltip({ record }: { record: GDFTafRecord }) {
    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content', columnGap: '0.5rem' }}>
                <div>Station:</div>
                <div>{record.id}</div>

                <div>Flight Cat:</div>
                <div>{flightCategoryToString[record.flightCategory]}</div>

                <div>Max Winds:</div>
                <div>
                    {record.windSpeed === null && <span>-</span>}
                    {record.windSpeed !== null && <span>{record.windSpeed} kts</span>}
                </div>

                {(record.storm || record.stormVicinity) && (
                    <>
                        <div>Convection:</div>
                        <div>
                            Thunderstorms
                            {record.stormVicinity && <span> in vicinity</span>}
                        </div>
                    </>
                )}

                <div>Ceiling:</div>
                <div>
                    {record.ceiling === null && '-'}
                    {record.ceiling === 0xfffe && <span>&gt; 12,000 ft ({feetToMeters(12_000)})</span>}
                    {record.ceiling !== null && record.ceiling !== 0xfffe && (
                        <span>
                            {(record.ceiling * 100).toLocaleString('en-US')} ft ({feetToMeters(record.ceiling * 100)})
                        </span>
                    )}
                </div>

                <div>Visibility:</div>
                <div>
                    {record.visibility === null && '-'}
                    {record.visibility === 0xfffe && <span>&gt; 10.50 SM</span>}
                    {record.visibility === 0xfffd && <span>CAVOK</span>}
                    {record.visibility !== null && record.visibility < 0xfffd && (
                        <span>
                            {record.visualLessGt && ltGt[record.visualLessGt]}
                            {(record.visibility / 100).toFixed(2)} SM
                        </span>
                    )}
                </div>
            </div>
            {record.text && (
                <div className="pt-3" style={{ maxWidth: 300, lineBreak: 'anywhere' }}>
                    {record.text}
                </div>
            )}
        </div>
    );
}
